import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import { usePermissions } from "../../common/PermissionContext";
import { useLocation, Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import Select from "react-select";
import Utils from "../../common/manipurCommon/Utils";

const SubMenus = () => {

    const [menuList, setMenuList] = useState<any[]>([]);
    const [subMenuList, setSubMenuList] = useState<any[]>([]);
    const [accountTypeList, setAccountTypeList] = useState<any[]>([]);
    const [accountTypeId, setAccountTypeId] = useState("");
    const [hasAccess, setHasAccess] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [subMenuId, setSubMenuId] = useState("");
    const [menuId, setMenuId] = useState("");
    const [subMenuName, setSubMenuName] = useState("");
    const [subMenuOrder, setSubMenuOrder] = useState("");
    const [subMenuRoute, setSubMenuRoute] = useState("");
    const [subMenuStatus, setSubMenuStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchSubMenus();
    }, [])

    async function fetchSubMenus() {
        setIsLoading(true);
        const sbmnuResponse = await func.listSubMenus();
        setSubMenuList(Array.isArray(sbmnuResponse) ? sbmnuResponse : [])
        setIsLoading(false);
    }

    const filteredData = subMenuList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const menuRender = (rowData) => {
        return <span>{rowData.menuTitle}</span>;
    };

    const subMenuNameRender = (rowData) => {
        return <span>{rowData.submenuTitle}</span>;
    };
    const subMenuOrderRender = (rowData) => {
        return <span>{rowData.submenuOrder}</span>;
    };

    const subMenuRouteRender = (rowData) => {
        return <span>{rowData.submenuRoute}</span>;
    };

    const subMenuStatusRender = (rowData) => {
        return <span>{(rowData.submenuStatus == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editSubMenu(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const sbmnuId = rowData.submenuId;

        return (
            <Link to="#" onClick={() => deleteSubMenu(sbmnuId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newSubMenu() {
        const accResponse = await func.accountType(null);
        setAccountTypeList(Array.isArray(accResponse) ? accResponse : [])
        setIsEdit(false)
        setOpenModal(true)
        setSubMenuName("");
        setMenuId("");
        setAccountTypeId("");
        setHasAccess("");
        setSubMenuRoute("");
        setSubMenuOrder("");
    }


    async function editSubMenu(rowData) {
        const sbmnuId = rowData.submenuId;
        setIsEdit(true)
        setOpenModal(true)
        const mnuResponse = await func.listMenus();
        setMenuList(Array.isArray(mnuResponse) ? mnuResponse : [])
        const accResponse = await func.accountType(null);
        setAccountTypeList(Array.isArray(accResponse) ? accResponse : [])
        const getDetails = await func.getSubmenu(sbmnuId);
        setSubMenuId(getDetails.submenuId);
        setSubMenuName(getDetails.submenuTitle);
        setMenuId(getDetails.menuId);
        setAccountTypeId(getDetails.accountAccess);
        setHasAccess(getDetails.hasSubmenuAccess);
        setSubMenuRoute(getDetails.submenuRoute);
        setSubMenuOrder(getDetails.submenuOrder);
        setSubMenuStatus(getDetails.submenuStatus);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateSubMenu();
            } else {
                if (subMenuName && menuId && subMenuRoute && subMenuOrder) {
                    const formData = new FormData();
                    formData.append("menuId", menuId);
                    formData.append("submenuTitle", subMenuName);
                    formData.append("submenuRoute", subMenuRoute);
                    formData.append("submenuOrder", subMenuOrder);
                    formData.append("hasSubmenuAccess", hasAccess);
                    formData.append("accountAccess", accountTypeId);

                    const createSubMenu = api.AddSubMenu;
                    fetch(createSubMenu, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Created',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        // window.location.reload(); // 🔁 Reload only after OK is clicked
                                        setOpenModal(false);
                                        fetchSubMenus();
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                })
                            }
                        })
                }
            }
        }
    }

    function updateSubMenu() {
        const formData = new FormData();
        formData.append("menuId", menuId);
        formData.append("submenuTitle", subMenuName);
        formData.append("submenuRoute", subMenuRoute);
        formData.append("submenuOrder", subMenuOrder);
        formData.append("hasSubmenuAccess", hasAccess);
        formData.append("accountAccess", accountTypeId);
        formData.append("submenuStatus", subMenuStatus);

        const updateSubMenu = api.UpdateSubMenu + '/' + subMenuId;
        fetch(updateSubMenu, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchSubMenus();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteSubMenu(sbmnuId: string) {
        const deleteRole = api.DeleteSubMenu + '/' + sbmnuId + '/' + 0;
        fetch(deleteRole, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchSubMenus();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Sub Menus</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newSubMenu() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Sub Menu">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="submenuTitle"
                                                header="Sub Menu Name"
                                                body={subMenuNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="menuTitle"
                                                header="Menu"
                                                body={menuRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="submenuRoute"
                                                header="Sub Menu Route"
                                                body={subMenuRouteRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="submenuOrder"
                                                header="Sub Menu Order"
                                                body={subMenuOrderRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="submenuStatus"
                                                header="Sub Menu Status"
                                                body={subMenuStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Sub Menu</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10">
                                    <label className="form-label">Account Access</label>
                                    <Select
                                        value={accountTypeList.find(acc => acc.accountTypeId === accountTypeId) ? {
                                            value: accountTypeId,
                                            label: accountTypeList.find(acc => acc.accountTypeId === accountTypeId)?.accountName
                                        } : null}
                                        onChange={async (e) => {
                                            setAccountTypeId(e.value);
                                            const mnuResponse = await func.listMenusByAccId(e.value);
                                            setMenuList(Array.isArray(mnuResponse) ? mnuResponse : [])
                                        }}
                                        required
                                        // styles={customSelect}
                                        placeholder="Select Account Type"
                                        options={accountTypeList.map(acc => ({
                                            value: acc.accountTypeId,
                                            label: acc.accountName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <label className="sortbytitle"><h6>Menu</h6></label>
                                    <Select
                                        value={menuList.find(menu => menu.menuId === menuId) ? {
                                            value: menuId,
                                            label: menuList.find(menu => menu.menuId === menuId).menuTitle
                                        } : null}
                                        onChange={(e) => {
                                            setMenuId(e.value);
                                        }}
                                        required
                                        placeholder="Select Menu"
                                        options={menuList.map(menu => ({
                                            value: menu.menuId,
                                            label: menu.menuTitle
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sub Menu Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="subMenuName"
                                            value={subMenuName}
                                            onChange={(e) => setSubMenuName(e.target.value)}
                                            placeholder="Sub Menu Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sub Menu Route</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="subMenuRoute"
                                            value={subMenuRoute}
                                            onChange={(e) => setSubMenuRoute(e.target.value)}
                                            placeholder="Sub Menu Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sub Menu Order</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="subMenuOrder"
                                            value={subMenuOrder}
                                            onChange={(e) => setSubMenuOrder(e.target.value)}
                                            placeholder="Sub Menu Order" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="row">
                                        <div className="mb-10 col-lg-4" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Has Menu Access</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    // required
                                                    checked={hasAccess === '1'}
                                                    id="hasAccess"
                                                    onChange={(e) => {
                                                        setHasAccess(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={subMenuStatus === '1'}
                                                        id="roleStatus"
                                                        onChange={(e) => {
                                                            setSubMenuStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default SubMenus;